import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styles from 'components/migration/_migrate.css'
import migrateHeaderComplete from 'images/migrate_header_complete.jpg'

import parse from 'url-parse'
import { connect } from 'react-redux'
import ReactCSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import { SubmissionError } from 'redux-form'
import { Loader } from 'components/util'

import * as auth from 'services/auth/selectors'
import * as authActions from 'services/auth/actions'
import * as site from 'services/site/selectors'
import * as migrateActions from 'services/migration/actions'

import MigrateForm from './MigrateForm'
import migrateHeader from 'images/migrate_header.jpg'

const mapStateToProps = (state, ownProps) => ({
  error: auth.selectError(state),
  loggingIn: auth.selectLoggingIn(state),
  dev: site.selectDev(state),
  token: ownProps.params.token,
  user: state.user,
})

const mapDispatchToActions = {
  ...authActions,
  ...migrateActions,
}

export class MigrateConfirmed extends Component {

  static propTypes = {
    loggingIn: PropTypes.bool,
    requestUser: PropTypes.func,
    confirmUser: PropTypes.func,
    login: PropTypes.func.isRequired,
    token: PropTypes.string,
    clearLegacy: PropTypes.func.isRequired,
    dev: PropTypes.bool,
    user: PropTypes.object,
  };

  state = {
    submitting: false,
    error: null,
    loggedIn: false,
  }

  componentWillMount () {
    this.props.clearLegacy()
  }

  handleLogin = ({ email, password }) => {
    const { dev } = this.props

    this.setState({ submitting: true, error: null, userError: null })

    return this.props.login({ username: email, password }, true)
      .then(this.onLoginSuccess)
      .catch((err) => {

        this.setState({ submitting: false, loggedIn: false })

        if (err.user) {
          // there was a problem reloading user
          // the user is probably still logged in
          if (dev) {
            err.url = parse(err.config.url, true)
            this.setState({ userError: err })
          } else {
            this.setState({ error: 'unknown' })
          }
        } else if (err
          && err.response
          && err.response.data
          && err.response.data.error
          && err.response.data.error === 'access_denied'
        ) {
          throw new SubmissionError({ _error: err.response.data.error })
        } else {
          this.setState({ error: 'unknown' })
        }
      })
  }

  onLoginSuccess = () => {
    const { dev } = this.props
    this.setState({ submitting: false, loggedIn: true })
    this.props.confirmUser(this.props.token)
    .catch((err) => {

      this.setState({ submitting: false, loggedIn: false })

      if (err.user) {
        // there was a problem reloading user
        // the user is probably still logged in
        if (dev) {
          err.url = parse(err.config.url, true)
          this.setState({ userError: err })
        } else {
          this.setState({ error: 'unknown' })
        }
      } else if (err
        && err.response
        && err.response.data
        && err.response.data.error
        && err.response.data.error === 'access_denied'
      ) {
        throw new SubmissionError({ _error: err.response.data.error })
      } else {
        this.setState({ error: 'unknown' })
      }
    })
  }

  getErrorMessage = (code) => {
    const messages = {
      'unknown': ('发生未知错误，请再试一次。'),
    }

    if (code in messages) {
      return messages[code]
    }
  }

  render () {
    const { dev } = this.props
    const { submitting, error, userError, loggedIn } = this.state

    return (
      <div className={styles.container}>
        <div>
          {loggedIn ?
            <div>
              <img src={migrateHeaderComplete} className={styles.headerImage} />

              <h2 className={styles.title}>
                转移确认
              </h2>
              <p className={styles.migrateParagraph}>
                正在转移您的数据。<br /><br />转移完成后，您将在接下来的几分钟内收到我们的电子邮件。
              </p>
            </div>
          :
            <div>
              <img src={migrateHeader} className={styles.headerImage} />
              <h2 className={styles.title}>
                操作之前，用户请注意：
              </h2>
              <p className={styles.migrateParagraph}>
                <ul>
                  <li>
                    在创建新账号，将现有数据迁入UA Run时，UA有权删除原先的UA MapMyRun账号信息. 这些信息将被立即删除，不可恢复.用户不可再使用UA MapMyRun中的账号或锻炼数据.
                  </li>
                  <li>
                    迁移数据之前，请先注销UA MapMyRun账号会员身份（若有）.
                  </li>
                  <li>
                    您的个人数据将被存储在中国.
                  </li>
                  <li>
                    UA Run受Under Armour条款与隐私政策的约束. 创建账号时，系统将提示要求您开放自己的个人数据并同意Under Armour收集、处理、存储自己的个人信息（包括健康与地理位置数据）.
                  </li>
                </ul>
              </p>
              <ReactCSSTransitionGroup
                component='div'
                transitionName='fade'
                transitionEnterTimeout={300}
                transitionLeaveTimeout={300}
                >
                {submitting ?
                  <div key='loader'>
                    <div className={styles.loader}>
                      <Loader height={50} width={50} />
                    </div>
                  </div>
                  : null}
              </ReactCSSTransitionGroup>

              {error ?
                <div className={styles.error}>
                  {this.getErrorMessage(error)}
                </div>
              : null}

              <MigrateForm
                loggingIn={submitting}
                onSubmit={this.handleLogin}
                confirmPage={true}
              />
            </div>
          }
        </div>
        {/*
          DEBUG information, only shown in local/devint
          Useful because DEVINT endpoints are often troublesome
        */}
        {userError && dev ?
          <div className={styles.userError}>
            <div className={styles.userErrorDescription}>
              You were logged in successfully, however there was an error fetching your user data.
              Feel free to try again, or just proceed to <a href="/my_home">my home</a>.
            </div>
            <div className={styles.userErrorMessage}>
              {userError.toString()} <br />
              {userError.response.status === 502 && 'Bad Gateway, server may be down or restarting'}
              {userError.response.status === 503 && 'Service Unavailable, server may be down or restarting'}
              {userError.response.status === 504 && 'Gateway Timeout, server took too long'}
            </div>
            <div><b>Host: </b>{userError.url.host}</div>
            <div><b>Path: </b>{userError.url.pathname}</div>
          </div>
        : null}
      </div>
    )
  }

}

export default connect(mapStateToProps, mapDispatchToActions)(MigrateConfirmed)
